import React from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
}
export const EmptyTablePlaceholder: React.FC<Props> = ({className}) => {
  const { t } = useTranslation();
  return (
    <div className={twMerge(cn("text-center text-gray-500 font-bold my-10", className))}>{t("not_found")}</div>
  );
};
